import { Link } from "react-router-dom";
import classNames from "../../utility/classNames";
import BrandLogoMark from "../Shared/Brand/BrandLogoMark";

const GROUP_LABELS = {
  // optional human labels if a group key isn't already prose
};

const DesktopSidebar = ({ navigation }) => {
  const groupedNavigation = navigation.reduce((acc, item) => {
    if (!acc[item.group]) {
      acc[item.group] = [];
    }
    acc[item.group].push(item);
    return acc;
  }, {});

  const groupEntries = Object.entries(groupedNavigation);

  return (
    <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
      <div className="flex grow flex-col gap-y-6 overflow-y-auto bg-cream-50 border-r border-ink-100 px-6 pb-4">
        <div className="flex h-16 shrink-0 items-center">
          <BrandLogoMark className="h-9 w-auto" />
        </div>
        <nav className="flex flex-1 flex-col">
          <ul className="flex flex-1 flex-col gap-y-5">
            {groupEntries.map(([group, items], groupIndex) => {
              const label = GROUP_LABELS[group] ?? group;
              const showLabel = label && groupEntries.length > 1;
              return (
                <li key={group}>
                  {showLabel && (
                    <h3 className="smallcaps text-ink-400 mb-2 px-2">
                      {label}
                    </h3>
                  )}
                  <ul className="-mx-2 space-y-0.5">
                    {items.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={item.href}
                          className={classNames(
                            "group relative flex gap-x-3 rounded-md py-2 pl-3 pr-2 text-sm font-medium leading-6 transition-colors",
                            item.current
                              ? "text-ink-900"
                              : "text-ink-500 hover:text-ink-900"
                          )}
                        >
                          {item.current && (
                            <span
                              aria-hidden="true"
                              className="absolute left-0 top-2 bottom-2 w-[2px] rounded-pill bg-accent-500"
                            />
                          )}
                          <item.icon
                            aria-hidden="true"
                            className={classNames(
                              "h-5 w-5 shrink-0 mt-0.5",
                              item.current
                                ? "text-accent-500"
                                : "text-ink-400 group-hover:text-ink-700"
                            )}
                          />
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                  {groupIndex < groupEntries.length - 1 && (
                    <div className="mt-5 border-t border-ink-100" />
                  )}
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default DesktopSidebar;
